/// <reference path="../../BaseNew/GAdmSeznamBase.ts"/>

namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class SeznamAdmPosta extends GContentBase<SeznamAdmPostaObj> {
        private seznamObj: SeznamAdmPostaObj & GContent;

        onContentReady() {
            this.seznamObj = $.extend(this as GContent, new SeznamAdmPostaObj());
            this.seznamObj.createBase({
                content: this,
                contentName: "seznamAdmPostaNew",
                contentCaption: "jres:33000098",
                dataListDescriptor: this.dataListDescription,
                comparatorSettings: {
                    itemTemplate: "{stat} - {psc}"
                },
                gridSettings: {
                    columnOrder: "stat_txt,psc,posta,dat_zmena,zmenu_provedl,ofic_nazev,priz_indiv_prir_txt"
                }
            })
            this.seznamObj.createBaseMenuBarActions();
            this.seznamObj.createFilter();
            this.seznamObj.createGrid();
        }
    }

    export class SeznamAdmPostaObj extends GAdmSeznamBase {
        create() {

        }

        openDetail(data: any, isNew: boolean) {
            $.content().navigate(["Gordic.Adm.WebControls.DetailAdmPosta", {
                currentFilter: this.filterData,
                gridRc: new Gordic.Components.GridRC(this.grid)
            }], {
                ID: "DetailAdmPosta",
                newRecord: isNew,
                stat: isNew == true ? null : data.stat,
                psc: isNew == true ? null : data.psc
            })
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return null
        }

        createBaseMenuBarActions() {
            this.cnt.menuBar(this.cnt.actions.createBar(["actOpenDetail*", "actNewDetail*", "actAddToComparison*", "actOpenDialogVyberovaSkupina*"]))
        }

        createContextMenu(): MenuParams[] {
            return this.cnt.actions.createBar(["actOpenDetail*"])
        }

        createFilterForm() {
            this.filterForm.addRow("jres:29802073").addField("gselectbox", Gordic.Prefabs.Select.gincsta(), {
                dropdown: true,
                model: "model.stat=value.stat",
                name: "stat",
            })
        }

        userhardDefaultFilter(hardFilter: any): any {
            return hardFilter;
        }

        collectData(data: any) {

        }

        applydata(filterData: any) {
            this.cnt.isl.AdmPosta.list({ filters: filterData }).getView().done((data) => {
                this.view = data;
                this.grid.ggrid('setData', this.view);
            });
        }

        selectionGridAct(objArr: IGGridSelection<any>) {

        }

        getSxs(data): IGAdmGridSxs {
            return {
                sxs: "{0}#{1}#".format(data.stat, data.psc),
                nazev: data["posta"]
            }
        }
    }
}